import {Link, Typography} from '@bonprix/design-system';
import {Touchpoint} from './ProductCard.jsx';
import {NOT_IN_TAB_BUT_IN_ARROW_ORDER} from '../../hooks/useGroupedFocus.js';

export default function ProductCardFeature({item, texts, touchpoint, handleSelectSizeClick}) {

    const ColorDisplayBlock = (
        <div className={`product-card_selection-element ${item.soldOut ? '' : 'product-card__link'}`}>
            <Typography component="span" color="text-on-background-mid"
                        variant={touchpoint === Touchpoint.ADD_TO_CART_SHEET ? 'body2' : 'body1'}>
                {texts.pc_color_descriptor}
            </Typography>
            &nbsp;
            <Typography component="span" color="text-on-background-mid"
                        variant={touchpoint === Touchpoint.ADD_TO_CART_SHEET ? 'body2' : 'body1'}>
                {item.colorText}
            </Typography>
        </div>
    );

    const shouldDisplaySizeBlock = item.hasMultipleItemOptions && (item.itemOptionId !== null || touchpoint === Touchpoint.ADD_TO_CART_SHEET || !item.soldOut)

    let sizeContent = null;

    if(item.sizeText) {
        sizeContent =
            <Typography component="span" variant={touchpoint === Touchpoint.ADD_TO_CART_SHEET ? "body2" : "body1"}>
                {item.sizeText}
            </Typography>
    } else if(handleSelectSizeClick) {
        sizeContent =
            <span className="product-card_details-size">
                <Link
                    button
                    hideUnderline={true}
                    onClick={handleSelectSizeClick}
                    tabIndex={NOT_IN_TAB_BUT_IN_ARROW_ORDER}
                >
                    <Typography component="span" variant={"body1"}>
                        {texts.pc_please_select}
                    </Typography>
                </Link>
            </span>
    } else if (touchpoint === Touchpoint.ADD_TO_CART_SHEET) {
        sizeContent =
            <Typography component="span" variant={"body2"}>
                {texts.pc_please_select}
            </Typography>
    }


    const SizeDisplayBlock = (
        <div className={`product-card_selection-element ${item.soldOut ? '' : 'product-card__link'}`}>
            {!item.coliArticle ? (
                <>
                    <Typography component='span' color='text-on-background-mid'
                                variant={touchpoint === Touchpoint.ADD_TO_CART_SHEET? 'body2' : 'body1'}>
                        {texts.pc_size_descriptor}
                    </Typography>
                    &nbsp;
                    {sizeContent}
                </>
            ) : null}
        </div>
    );

    const VariantDisplayBlock = (
        <div className={`product-card_selection-element`}>
            {item.variantText ? (
                <>
                    <Typography component="span" color="text-on-background-mid" variant={touchpoint === Touchpoint.ADD_TO_CART_SHEET ? "body2" : "body1"}>
                        {texts.pc_variant}:
                    </Typography>
                    &nbsp;
                    <Typography component="span" color="text-on-background-mid" variant={touchpoint === Touchpoint.ADD_TO_CART_SHEET ? "body2" : "body1"}>
                        {item.variantText}
                    </Typography>
                </>
            ) : (
                <Typography component="span" color="text-on-background-mid" variant={touchpoint === Touchpoint.ADD_TO_CART_SHEET ? "body2" : "body1"}>
                    {" "}
                </Typography>
            )}
        </div>
    )

    return (
        <div className={`product-card_details-area_selections touchpoint-${touchpoint}`}>
            {ColorDisplayBlock}
            {shouldDisplaySizeBlock ? SizeDisplayBlock : null}
            {VariantDisplayBlock}
        </div>
    );

}
